import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Student from '@/components/Student'
import BatchOperation from '@/components/BatchOperation'
import School from '@/components/School'
import Class from '@/components/Class'
import Grade from '@/components/Grade'
import StaffGroup from '@/components/StaffGroup'
import Telzone from '@/components/Telzone'
import Attendence from '@/components/Attendence'
import ReaderRecord from '@/components/ReaderRecord'
import Order from '@/components/Order'
import Refund from '@/components/Refund'
import ChangeCard from '@/components/ChangeCard'
import StatsForOrder from '@/components/StatsForOrder'
import StatsForYearFee from '@/components/StatsForYearFee'
import StatsForOrderAmount from '@/components/StatsForOrderAmount'
import SendMessage from '@/components/SendMessage'
import SendCourseMessage from '@/components/SendCourseMessage'
import SendSalaryMessage from '@/components/SendSalaryMessage'
import NotifyRecord from '@/components/NotifyRecord'
import Test from '@/components/Test'
import Manager from '@/components/Manager'
import GenerateCaptcha from '@/components/GenerateCaptcha'
import UserCardNoChangeHistory from '@/components/UserCardNoChangeHistory'
import MessageSendForAttendance from '@/components/MessageSendForAttendance'
import MessageSendForNotify from '@/components/MessageSendForNotify'
import StatsForStudentReader from '@/components/StatsForStudentReader'
import StatsForClassStudentReader from '@/components/StatsForClassStudentReader'
import CanteenSettings from '@/components/CanteenSettings'
import CanteenGoods from '@/components/CanteenGoods'
import CanteenAccount from '@/components/CanteenAccount'
import CanteenWeekMenu from '@/components/CanteenWeekMenu'
import CanteenOrder from '@/components/CanteenOrder'
import CanteenOrderDetail from '@/components/CanteenOrderDetail'
import CanteenTransaction from '@/components/CanteenTransaction'
import CanteenMonthReport from '@/components/CanteenMonthReport'
import CardPicture from '@/components/CardPicture'
import MeetingPicture from '@/components/MeetingPicture'
import AttendenceStats from '@/components/AttendenceStats'
import AttendenceStatsWeek from '@/components/AttendenceStatsWeek'
import AttendenceStatsMonth from '@/components/AttendenceStatsMonth'
import AttendenceStatsOfNingweiMiddleSchool from '@/components/AttendenceStatsOfNingweiMiddleSchool'
import BodyTemperatureCollection from '@/components/BodyTemperatureCollection'
import SchoolWorkDay from '@/components/SchoolWorkDay'
import FaceImage from '@/components/FaceImage'
import TianqiaoTempMeetingFace from '@/components/TianqiaoTempMeetingFace'
import StrangerMeetingRecord from '@/components/StrangerMeetingRecord'
import StatsForReadRate from '@/components/StatsForReadRate'
import StudentCanteenGoods from '@/components/StudentCanteenGoods'
import StudentCanteenSchedule from '@/components/StudentCanteenSchedule'
import StudentCanteenMenu from '@/components/StudentCanteenMenu'
import StudentCanteenOrder from '@/components/StudentCanteenOrder'
import TianqiaoDevice from '@/components/TianqiaoDevice'
import FacultyScanAttendance from '@/components/FacultyScanAttendance'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/login',
      name: 'login page',
      component: Login
    },
    {
      path: '/manager',
      name: 'manager page',
      component: Manager
    },
    {
      path: '/student',
      name: 'student page',
      component: Student
    },
    {
      path: '/batchOperation',
      name: 'batch operation page',
      component: BatchOperation
    },
    {
      path: '/school',
      name: 'school page',
      component: School
    },
    {
      path: '/class',
      name: 'class page',
      component: Class
    },
    {
      path: '/grade',
      name: 'grade page',
      component: Grade
    },
    {
      path: '/staffGroup',
      name: 'staff group page',
      component: StaffGroup
    },
    {
      path: '/telzone',
      name: 'telzone page',
      component: Telzone
    },
    {
      path: '/attendence',
      name: 'attendence page',
      component: Attendence
    },
    {
      path: '/readerRecord',
      name: 'reader record page',
      component: ReaderRecord
    },
    {
      path: '/order',
      name: 'order page',
      component: Order
    },
    {
      path: '/refund',
      name: 'refund page',
      component: Refund
    },
    {
      path: '/changeCard',
      name: 'change card page',
      component: ChangeCard
    },
    {
      path: '/statsForOrder',
      name: 'stats for order page',
      component: StatsForOrder
    },
    {
      path: '/statsForYearFee',
      name: 'stats for year fee',
      component: StatsForYearFee
    },
    {
      path: '/statsForOrderAmount',
      name: 'stats for order amount',
      component: StatsForOrderAmount
    },
    {
      path: '/sendMessage',
      name: 'send message',
      component: SendMessage
    },
    {
      path: '/sendCourseMessage',
      name: 'send course message',
      component: SendCourseMessage
    },
    {
      path: '/sendSalaryMessage',
      name: 'send salary message',
      component: SendSalaryMessage
    },
    {
      path: '/notifyRecord',
      name: 'notify record',
      component: NotifyRecord
    },
    {
      path: '/generateCaptcha',
      name: 'generate captcha',
      component: GenerateCaptcha
    },
    {
      path: '/userCardNoChangeHistory',
      name: 'user card no change history',
      component: UserCardNoChangeHistory
    },
    {
      path: '/messageSendForAttendance',
      name: 'message send for attendance',
      component: MessageSendForAttendance
    },
    {
      path: '/messageSendForNotify',
      name: 'message send for notify',
      component: MessageSendForNotify
    },
    {
      path: '/statsForStudentReader',
      name: 'stats for student reader',
      component: StatsForStudentReader
    },
    {
      path: '/statsForClassStudentReader',
      name: 'stats for class student reader',
      component: StatsForClassStudentReader
    },
    {
      path: '/canteenSettings',
      name: 'canteen settings',
      component: CanteenSettings
    },
    {
      path: '/canteenAccount',
      name: 'canteen account',
      component: CanteenAccount
    },
    {
      path: '/canteenGoods',
      name: 'canteen goods',
      component: CanteenGoods
    },
    {
      path: '/canteenWeekMenu',
      name: 'canteen week menu',
      component: CanteenWeekMenu
    },
    {
      path: '/canteenOrder',
      name: 'canteen order',
      component: CanteenOrder
    },
    {
      path: '/canteenOrderDetail',
      name: 'canteen order detail',
      component: CanteenOrderDetail
    },
    {
      path: '/canteenTransaction',
      name: 'canteen transaction',
      component: CanteenTransaction
    },
    {
      path: '/canteenMonthReport',
      name: 'canteen month report',
      component: CanteenMonthReport
    },
    {
      path: '/cardPicture',
      name: 'card picture',
      component: CardPicture
    },
    {
      path: '/meetingPicture',
      name: 'meeting picture',
      component: MeetingPicture
    },
    {
      path: '/attendenceStats',
      name: 'attendence stats',
      component: AttendenceStats
    },
    {
      path: '/attendenceStatsWeek',
      name: 'attendence stats week',
      component: AttendenceStatsWeek
    },
    {
      path: '/attendenceStatsMonth',
      name: 'attendence stats month',
      component: AttendenceStatsMonth
    },
    {
      path: '/attendenceStatsOfNingweiMiddleSchool',
      name: 'attendence stats of Ningwei middle school',
      component: AttendenceStatsOfNingweiMiddleSchool
    },
    {
      path: '/bodyTemperatureCollection',
      name: 'body temperature collection',
      component: BodyTemperatureCollection
    },
    {
      path: '/schoolWorkDay',
      name: 'school work day',
      component: SchoolWorkDay
    },
    {
      path: '/faceImage',
      name: 'face image',
      component: FaceImage
    },
    {
      path: '/tianqiaoTempMeetingFace',
      name: 'tianqiao temp meeting face',
      component: TianqiaoTempMeetingFace
    },
    {
      path: '/strangerMeetingRecord',
      name: 'stranger meeting record',
      component: StrangerMeetingRecord
    },
    {
      path: '/statsForReadRate',
      name: 'stats for read rate',
      component: StatsForReadRate
    },
    {
      path: '/studentCanteenGoods',
      name: 'student canteen goods',
      component: StudentCanteenGoods
    },
    {
      path: '/studentCanteenSchedule',
      name: 'student canteen schedule',
      component: StudentCanteenSchedule
    },
    {
      path: '/studentCanteenMenu',
      name: 'student canteen menu',
      component: StudentCanteenMenu
    },
    {
      path: '/studentCanteenOrder',
      name: 'student canteen order',
      component: StudentCanteenOrder
    },
    {
      path: '/tianqiaoDevice',
      name: 'tianqiao device',
      component: TianqiaoDevice
    },
    {
      path: '/facultyScanAttendance',
      name: 'faculty scan attendance',
      component: FacultyScanAttendance
    },
    {
      path: '/test',
      name: 'test page',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js